// src/js/components/random-phrase.js
import { FRASES_INSPIRADORAS } from '../frases.js';

document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".js-random-phrase");
  
  // Aborta si no hay frase.json o no hay contenedor en el HTML actual (ej: index.html)
  if (!containers.length || !FRASES_INSPIRADORAS || FRASES_INSPIRADORAS.length === 0) return;

  // Seleccionar una frase aleatoria del array
  const randomIndex = Math.floor(Math.random() * FRASES_INSPIRADORAS.length);
  const fraseSeleccionada = FRASES_INSPIRADORAS[randomIndex];

  // Inyectar en los nodos
  containers.forEach(container => {
    container.textContent = fraseSeleccionada;
  });
});
